import { Amenity } from '@data/types/common';
import AccommodationSourceSettings from './AccommodationSourceSettings';
import { AccomodationUnit } from './AccomodationUnit';
import Image from './Image';

import Store from '@data/stores/Store';

function extractPackageName(roomName: string, roomTitle: string): string {
  if (roomName === roomTitle) return 'Standard Rate';
  return roomTitle.substring(roomName.length + 2, roomTitle.length - 1);
}

export default class Accommodation {
  id!: string;
  packageId!: string;
  packageTerms!: string;
  rateId!: string;
  name!: string;
  title!: string;
  packageName!: string;
  description!: string;
  adults!: number;
  kids!: number;
  beds!: number;
  maxGuests!: number;
  available!: number;
  notDerivedRate!: number;
  rate!: number;
  nights!: number;
  maxRooms!: number;
  numBeds!: number;
  amenities!: Amenity[];
  images!: Image[];
  isPackage!: boolean;
  isPrivate!: boolean;
  policy!: string;
  accommodations!: AccomodationUnit[];
  sourceSettings!: AccommodationSourceSettings;
  packageDescription!: string;

  constructor(data: undefined | any = {}) {
    this.id = data.room_type_id.toString();
    this.packageId = data.package_id.toString();
    this.rateId = data.rate_id.toString();
    this.packageTerms = data.package_terms;
    this.name = data.room_type_name;
    this.title = data.room_type_title;
    this.packageName = extractPackageName(this.name, this.title);
    this.description = data.room_type_desc;
    this.beds = data.num_beds;
    this.adults = data.adults_inBasePrice;
    this.kids = data.children_inBasePrice;
    this.notDerivedRate = data.not_derived_price?.rate_basic || 0;
    this.rate = data.rate_basic;
    this.isPrivate = data.is_private === 'Y';
    this.packageDescription = data.package_desc;
    this.isPackage = data.is_package === 1;

    this.sourceSettings = Store.property.model?.roomsSourceSettings?.find(
      (room) => room.roomTypeId === this.id
    ) || {
      bookableLimit: 0,
      capacity: 0,
      canSelectSpecificRoom: false,
      maxRooms: 0,
      roomTypeId: this.id,
      title: this.title,
    };

    this.accommodations = [];
    if (data.accommodations) {
      const keys = Object.keys(data.accommodations);
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        const accommodation = data.accommodations[key];
        this.accommodations.push({
          name: accommodation.name,
          description: accommodation.description,
          group_name: accommodation.group_name,
          hasDescription: accommodation.has_description,
          images: accommodation.images.map((image: any) => new Image(image)),
          room_id: accommodation.room_id.toString(),
          room_position: accommodation.room_position,
        });
      }
    }

    // This policy value depends on an implementation from the Smart Policies team in MFD
    // it should be implemented in the future
    this.policy = '';

    const { detailed_rates = [] } = data;
    this.nights = detailed_rates.length;

    this.maxGuests = data.max_guests;
    this.maxRooms = data.max_rooms;
    this.numBeds = parseInt(data.num_beds || '1');
    this.available = data.num_available_now;

    this.images = data.photos_gallery.map((src: string, index: number) => ({
      src: src,
      thumb: src,
      alt: data.photos_gallery_alt[index],
    }));

    this.amenities = data.features?.map((name: string) => ({
      name,
    }));
  }
}
